module.exports = __webpack_public_path__ + "static/media/3_3.2d683563.png";